/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MedPillsIcon20Solid = forwardRef('MedPillsIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.207 9.183a3.984 3.984 0 1 0 5.634 5.635l6.961-6.961a3.984 3.984 0 1 0-5.635-5.635l-6.96 6.96Zm5.071-2.95 3.513 3.513 2.95-2.95a2.484 2.484 0 0 0-3.513-3.513l-2.95 2.95Z" }),
        React.createElement("path", { d: "M19 15a4 4 0 0 1-6.305 3.27l5.575-5.575c.46.652.73 1.447.73 2.305Z" }),
        React.createElement("path", { d: "M15 11c.9 0 1.73.297 2.398.799l-5.6 5.6A4 4 0 0 1 15 11Z" })));
});
